module.exports = __webpack_public_path__ + "static/media/popcorn.96e499b5.png";